import React, { forwardRef, useEffect, useMemo, useContext } from "react";
import { cx } from "@linaria/core";
import { SelectContext } from "../state";
import {
  OptionWrapper,
  Checkmark,
  CheckboxOn,
  CheckboxOff
} from "./Select.styles";
const filterOrAddValue = (T1, T2) => {
  return T1?.includes(T2) ? T1?.filter((x) => x !== T2) : [...T1, T2];
};
const Option = ({
  children,
  disabled = false,
  value,
  className,
  innerRef
}) => {
  const {
    onChange,
    setIsExpanded,
    menuId,
    registerOption,
    selectedValue,
    selectedValues,
    isMultiselect,
    filteredOptions
  } = useContext(SelectContext);
  const showOption = filteredOptions.includes(value);
  const isSelected = isMultiselect ? selectedValues.includes(value) : selectedValue === value;
  const classNames = cx(isSelected && "is-selected", isMultiselect && "is-multiselect", disabled && "is-disabled", className);
  useEffect(() => {
    registerOption(value, disabled);
  }, [registerOption, value, disabled]);
  return useMemo(() => {
    const handleOnClick = (event) => {
      if (disabled)
        return;
      event.preventDefault();
      event.stopPropagation();
      const newEvent = { ...event };
      if (isMultiselect) {
        const newValues = filterOrAddValue(selectedValues, value);
        newEvent.target.value = newValues;
      } else {
        newEvent.target.value = value;
        setIsExpanded(false);
      }
      onChange(newEvent);
    };
    if (!showOption)
      return null;
    return /* @__PURE__ */ React.createElement(OptionWrapper, {
      role: "option",
      onClick: handleOnClick,
      className: classNames,
      "aria-selected": isSelected,
      id: `${menuId}_${value}`,
      ref: innerRef
    }, children, isMultiselect && isSelected && /* @__PURE__ */ React.createElement(CheckboxOn, null), isMultiselect && !isSelected && /* @__PURE__ */ React.createElement(CheckboxOff, null), !isMultiselect && isSelected && /* @__PURE__ */ React.createElement(Checkmark, null));
  }, [
    innerRef,
    children,
    classNames,
    disabled,
    isMultiselect,
    isSelected,
    menuId,
    onChange,
    selectedValues,
    setIsExpanded,
    showOption,
    value
  ]);
};
export default forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Option, {
  ...props,
  innerRef: ref
}));
